<template>
  <div class="home-page">
    <h1>Welcome to LBC Vue App</h1>
    <p>Your one-stop solution for managing your bike club events and activities.</p>
  </div>
</template>

<script>
export default {
  name: "HomePage",
};
</script>

<style scoped>
.home-page {
  text-align: center;
  margin-top: 50px;
}
</style>